interface Props { text: string; }

/** Renders words as inline-block spans for Word Cascade; real text stays readable/selectable. */
export default function SplitWords({ text }: Props) {
  const words = text.split(' ');
  return (
    <>
      {words.map((w, i) => (
        <span key={`${w}-${i}`}>
          <span data-w className="inline-block">{w}</span>
          {i < words.length - 1 ? ' ' : ''}
        </span>
      ))}
    </>
  );
}